import { render, staticRenderFns } from "./CategoryFormItem.vue?vue&type=template&id=3e49bf1a&scoped=true&"
import script from "./CategoryFormItem.vue?vue&type=script&lang=js&"
export * from "./CategoryFormItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFormItem.vue?vue&type=style&index=0&id=3e49bf1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e49bf1a",
  null
  
)

export default component.exports